/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Optional metadata for repost operations
 * @export
 * @interface RepostRequestBody
 */
export interface RepostRequestBody {
    /**
     * Set to true when reposting an item that was reposted (used for notifications)
     * @type {boolean}
     * @memberof RepostRequestBody
     */
    isRepostOfRepost?: boolean;
}

/**
 * Check if a given object implements the RepostRequestBody interface.
 */
export function instanceOfRepostRequestBody(value: object): value is RepostRequestBody {
    let isInstance = true;

    return isInstance;
}

export function RepostRequestBodyFromJSON(json: any): RepostRequestBody {
    return RepostRequestBodyFromJSONTyped(json, false);
}

export function RepostRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepostRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isRepostOfRepost': !exists(json, 'is_repost_of_repost') ? undefined : json['is_repost_of_repost'],
    };
}

export function RepostRequestBodyToJSON(value?: RepostRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_repost_of_repost': value.isRepostOfRepost,
    };
}

